// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__25dig","spin":"loader_spin__dNrTZ"};